import axios from 'axios';
import { getBackendURL } from '@/util.js';

export default class UserService {
    constructor() {
        const baseURL = getBackendURL();
        this.urls = {
            createUser: `${baseURL}/v1/user/create`,
            me: `${baseURL}/v1/user/me`,
            updateUser: `${baseURL}/v1/user/update`,
        }
    }

    getErrorMsgForCreateUser(error) {
        if (error.response?.status !== 409) {
            return ""; // blank means default error msg
        }
        if (error.response.data.includes("username")) {
            return 'Username already exists, please try another one';
        } else if (error.response.data.includes("email")) {
            return `Email already exists`;
        } else {
            return "";
        }
    }

    async createUser(username) {
        let res = {
            data: null,
            error: null
        }
        try {
            const response = await axios.post(this.urls.createUser, {
                username: username,
            }, {
                withCredentials: true
            });
            res.data = response.data;
        } catch (error) {
            res.error = this.getErrorMsgForCreateUser(error);
        }
        return res;
    }

    async getMe() {
        let res = {
            data: null,
            error: null
        }
        try {
            const response = await axios.get(this.urls.me, {
                withCredentials: true
            });
            res.data = response.data;
        } catch (error) {
            res.error = error;
        }
        return res;
    }

    async updateUser(user) {
        let res = {
            error: null
        }
        try {
            await axios.put(this.urls.updateUser, user, {
                withCredentials: true
            });
        } catch (error) {
            res.error = error;
        }
        return res;
    }
}
